import { BaseModel } from '../../base/base-model'

/**
 * @memberOf loavies.models.listing
 * @constructor
 */
export class UpdateListingPublicDataModel extends BaseModel {
  /**
   * @param {string} [productGroup]
   * @param {string} [color]
   * @param {string} [size]
   * @param {string} [condition]
   * @param {number} [timesWatched]
   * @param {number} [timesShared]
   * @param {number} [wishlistCount]
   * @param {loavies.models.listing.ListingDiscountModel} [discount]
   * @param {string} [labelId]
   * @param {string} [publishedAt] ISO 8601
   * @param {number} [shopIndex]
   * @param {string} [magentoSku]
   */
  constructor({
    productGroup,
    color,
    size,
    condition,
    timesWatched,
    timesShared,
    wishlistCount,
    discount,
    labelId,
    publishedAt,
    shopIndex,
    magentoSku,
  }) {
    super()

    /** @type {string} */
    if (!this.isUndefined(productGroup)) this.productGroup = productGroup

    /** @type {string} */
    if (!this.isUndefined(color)) this.color = color

    /** @type {string} */
    if (!this.isUndefined(size)) this.size = size

    /** @type {string} */
    if (!this.isUndefined(condition)) this.condition = condition

    /** @type {number} */
    if (!this.isUndefined(timesWatched)) this.timesWatched = timesWatched

    /** @type {number} */
    if (!this.isUndefined(timesShared)) this.timesShared = timesShared

    /** @type {number} */
    if (!this.isUndefined(wishlistCount)) this.wishlistCount = wishlistCount

    /** @type {loavies.models.listing.ListingDiscountModel} */
    if (!this.isUndefined(discount)) this.discount = discount

    /** @type {string} */
    if (!this.isUndefined(labelId)) this.labelId = labelId

    /** @type {string} ISO 8601 */
    if (!this.isUndefined(publishedAt)) this.publishedAt = publishedAt

    /** @type {number} */
    if (!this.isUndefined(shopIndex)) this.shopIndex = shopIndex

    /** @type {number} */
    if (!this.isUndefined(magentoSku)) this.magentoSku = magentoSku
  }
}

